export default {
  data() {
    return {
      search: '',
      terms: !this.$route.query.terms ? [] : Array.isArray(this.$route.query.terms) ? this.$route.query.terms : [this.$route.query.terms],
    };
  },
  methods: {
    searchList() {},
    handleSearchList(search) {
      /**
       * @see https://github.com/vuejs/vue-router/issues/1690
       * As array are immutable, we need to create a new reference to the array
       * so the observer can get the changes
       */
      if (search && search != '') { this.terms = [...this.terms, search]; }
      this.searchList();
      this.$router.push({ query: { page: this.currentPage, terms: this.terms }});
    },
    removeTerm(id) {
      /**
       * @see https://github.com/vuejs/vue-router/issues/1690
       * As array are immutable, we need to create a new reference to the array
       * so the observer can get the changes
       */
      this.terms = [...this.terms];
      this.terms.splice(id, 1);
      this.currentPage = 1;
      this.handleSearchList();
    }
  },
  watch: {
    terms: function(newValue, oldValue) {
      if (this.terms.length > 0) {
        this.handleSearchList();
      }
    }
  }
};